<template>
  <van-popup
    class="system-kefu"
    position="bottom"
    getContainer="body"
    round="false"
    closeable
    v-model="opened"
    :close-on-click-overlay="true"
    >
    <div class="title van-hairline--bottom">「校管家客服」贴心为您服务</div>
    <div class="wrapper">
      <iframe class="kefu-iframe" :src="opts.kefuUrl" frameborder="0"></iframe>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'system-kefu',
  data() {
    return {
      opened: false,
      opts: {
        kefuUrl: ''
      }
    }
  },
  methods: {
    show(opts) {
      this.opened = true;
      Object.assign(this.opts, opts);
      return new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
      });
    },
    confirm(val) {
      this._resolve(this.opts);
      this.opened = false;
    },
    cancel(type) {
      this._reject(type);
      this.opened = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.system-kefu {
  width: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  transform: none;
  top: inherit;
  .title {
    padding: 0 calc(var(--gap) * 8);
    height: calc(var(--w) * 48);
    line-height: calc(var(--w) * 48);
  }
  .wrapper {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    height: calc(var(--gap) * 500);
  }
  .kefu-iframe {
    border: none;
    width: 100%;
    height: calc(var(--gap) * 500);
  }
}
</style>